// mparle-cart-drawer.js
// Server-side gerenderde drawer (via Section Rendering API). Bij elke wijziging
// haalt de drawer een fresh /?section_id=mparle-cart-drawer fetch op en vervangt
// het oude blok — geen client-side templating met user-data.
(function () {
  const SECTION_URL = '/?section_id=mparle-cart-drawer';
  const overlay = document.querySelector('[data-mp-cart-overlay]');
  const root = document.querySelector('[data-mp-cart-root]');
  if (!overlay || !root) return;

  let busy = false;

  const drawer = () => root.querySelector('[data-mp-cart]');

  function open() {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('mp-no-scroll');
    d.setAttribute('aria-hidden', 'false');
    d.removeAttribute('inert');
  }

  function close() {
    const d = drawer();
    if (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('inert', '');
    }
    overlay.classList.remove('is-open');
    document.body.classList.remove('mp-no-scroll');
  }

  function syncHeaderCount(html) {
    const match = html.match(/data-mp-drawer-count[^>]*>\s*(\d+)\s*</);
    if (!match) return;
    const count = match[1];
    document.querySelectorAll('[data-mp-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  }

  async function refresh() {
    const res = await fetch(SECTION_URL, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`drawer refresh ${res.status}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-mp-cart]');
    const current = drawer();
    if (!fresh || !current) return;
    const wasOpen = current.classList.contains('is-open');
    current.replaceWith(fresh);
    if (wasOpen) {
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden', 'false');
      fresh.removeAttribute('inert');
    }
    bind(fresh);
    syncHeaderCount(html);
  }

  async function changeLine(key, target) {
    if (busy) return;
    busy = true;
    try {
      let quantity = target;
      if (target !== 0) {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        const item = cart.items.find((i) => i.key === key);
        quantity = Math.max(0, (item ? item.quantity : 0) + target);
      }
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error(`cart change ${res.status}`);
      await refresh();
    } finally {
      busy = false;
    }
  }

  function bind(d) {
    if (!d) return;
    const closeBtn = d.querySelector('[data-mp-cart-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    d.querySelectorAll('[data-mp-cart-close]').forEach((el) => el.addEventListener('click', close));
    d.querySelectorAll('[data-mp-qty]').forEach((btn) =>
      btn.addEventListener('click', () => changeLine(btn.dataset.key, parseInt(btn.dataset.mpQty, 10)))
    );
    d.querySelectorAll('[data-mp-remove]').forEach((btn) =>
      btn.addEventListener('click', () => changeLine(btn.dataset.key, 0))
    );
  }

  document.querySelectorAll('[data-mp-cart-open]').forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    })
  );

  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  function formItem(form) {
    const fd = new FormData(form);
    const id = fd.get('id');
    if (!id) return null;
    const quantity = parseInt(fd.get('quantity'), 10) || 1;
    const properties = {};
    for (const [key, value] of fd.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    }
    const item = { id: Number(id), quantity };
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('[data-mp-cart-form]')) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    try {
      const mainItem = formItem(form);
      if (!mainItem) return;
      const items = [mainItem];

      const giftCheckbox = form.querySelector('[data-mp-gift-checkbox]');
      const giftVariantId = form.dataset.mpGiftVariantId;
      if (giftCheckbox && giftCheckbox.checked && giftVariantId) {
        items.push({
          id: Number(giftVariantId),
          quantity: 1,
          parent_id: mainItem.id,
          properties: { _nonce: Math.random().toString(36).slice(2, 10) },
        });
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('cart/add failed', err);
        return;
      }
      await refresh();
      open();
    } finally {
      busy = false;
    }
  });

  bind(drawer());

  // Publieke hook voor andere modules (bv. mparle-card-add.js) om de drawer
  // te verversen en te openen na een externe /cart/add.js call.
  document.addEventListener('mp:cart:refresh-and-open', async () => {
    if (busy) return;
    busy = true;
    try {
      await refresh();
      open();
    } finally {
      busy = false;
    }
  });
})();
